import { FC, PropsWithChildren, useEffect, useRef } from "react";

interface InfiniteScrollProps extends PropsWithChildren {
  isFetching: boolean;
  hasNextPage: boolean;
  fetchNextPage: () => void;
}

const InfiniteScroll: FC<InfiniteScrollProps> = ({
  isFetching,
  hasNextPage,
  fetchNextPage,
  children,
}) => {
  const bottomRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting && !isFetching && hasNextPage) {
        fetchNextPage();
      }
    });
    const observerTarget = bottomRef.current!;
    observer.observe(observerTarget);
    return () => {
      observer.unobserve(observerTarget);
    };
  }, [fetchNextPage, hasNextPage, isFetching]);
  return (
    <>
      {children}
      {isFetching ? (
        <div className="flex justify-center items-center min-h-8">
          <span className="loading loading-spinner text-primary"></span>
        </div>
      ) : null}
      <div ref={bottomRef} />
    </>
  );
};

export default InfiniteScroll;
